export default __webpack_public_path__ + "static/media/BurnCroFounder.6343ef82.png";